import AdvancedSearchM from '../model/recordm.model.advancedsearch.js';
import SimpleSearchM from '../model/recordm.model.simplesearch.js';

// Responsible to export all instances selected
// or that match a query
var ExportInstances = function(core) {

    var _getSearchM = function(req) {
        var query = req.query,
            definitionId = req.definitionId,
            isAdvSearch = false,
            advQuery,
            searchM;

        if (req.query) {

            try {
                advQuery = JSON.parse(req.query);

                // JSON.parse(10) returns 10 and will not throw any exception
                isAdvSearch = (typeof advQuery === 'object');

            } catch (e) {
                window.console.log("INFO: Conversion to json failed so I will handle it has a query string", req.query);
            }
        }

        if (isAdvSearch) {
            searchM = new AdvancedSearchM(core,
                "recordm/definitions/search/advanced/" + definitionId,
                "recordm/definitions/search/download/advanced/" + definitionId,
                "recordm/definitions/search/download/" + definitionId
            );
        } else {
            searchM = new SimpleSearchM(
                core,
                "recordm/definitions/search/" + definitionId,
                "recordm/definitions/search/download/" + definitionId
            );
        }

        searchM.setCurrentQuery(!isAdvSearch ? query : advQuery);

        return searchM;
    };

    var _execute = function(req, ctx) {
        var searchM = _getSearchM(req),
            exportUrl = searchM.getExportURL(req.ids, ctx.visibleColumns, ctx.columnLabels);

        window.open(exportUrl, "_blank");
    };

    return {
        execute: _execute
    }
};

export default ExportInstances;
